import React from 'react';
import { ReactComponent as MagicIcon } from 'src/assets/icons/magic-icon.svg';
import { ReactComponent as MessageIcon } from 'src/assets/icons/message.svg';
import { ReactComponent as ThreadIcon } from 'src/assets/icons/thread.svg';

import {
  Wrapper,
  Banner,
  BannerItem,
  MagicIconWrapper,
  MessageIconWrapper,
  MetricNumberWrapper,
  ThreadIconWrapper,
  MetricDescription,
  Divider
} from './PartnerDeploymentMetrics.style';

const PartnerDeploymentMetrics = () => {
  return (
    <Wrapper>
      <Banner>
        <BannerItem>
          <MessageIconWrapper>
            <MessageIcon width={30} height={30} />
          </MessageIconWrapper>
          <MetricNumberWrapper>0/20</MetricNumberWrapper>
          <MetricDescription>Customers deployed chat</MetricDescription>
        </BannerItem>
        <Divider />
        <BannerItem>
          <ThreadIconWrapper>
            <ThreadIcon width={30} height={30} />
          </ThreadIconWrapper>
          <MetricNumberWrapper>0</MetricNumberWrapper>
          <MetricDescription>Threads in the last 90 days</MetricDescription>
        </BannerItem>
        <Divider />
        <BannerItem>
          <MagicIconWrapper>
            <MagicIcon width={30} height={30} />
          </MagicIconWrapper>
          <MetricNumberWrapper>0</MetricNumberWrapper>
          <MetricDescription>Clients running Magic AI</MetricDescription>
        </BannerItem>
      </Banner>
    </Wrapper>
  );
};

export default PartnerDeploymentMetrics;
